import type { ComponentProps } from "@blocknote/react";
import { RawTextInputWithExtra } from "ui";
type Props = ComponentProps["Generic"]["Form"]["TextInput"];

export function TextInput({ onChange, onKeyDown, placeholder, value, autoFocus, icon, className }: Props) {
  return (
    <RawTextInputWithExtra
      extra={icon}
      onKeyDown={onKeyDown}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      autoFocus={autoFocus}
    />
  );
}
